import { ResourceItem, IncompleteResourceItem } from "../ResourceItem";

import { createFullClassResource } from "../../fullResource";
import {
  apiField,
  constructFromApiData,
  getApiPostData,
} from "../ResourceItemMetadata";

export class User extends ResourceItem {
  @apiField()
  email: string = "";
  @apiField()
  firstName: string = "";
  @apiField()
  lastName: string = "";

  @apiField({ readOnly: true })
  groups!: IncompleteResourceItem[];

  constructor(data: any) {
    super(data);

    if (data) constructFromApiData(this, data);
  }

  getPostData() {
    return getApiPostData(this);
  }

  get fullName(): string {
    return this.firstName + " " + this.lastName;
  }
}

export const userResource = createFullClassResource(
  "iam/users/",
  User,
  (u) => ({ ...u, str: u.email }),
);
